import DateFnsUtils from "@date-io/date-fns";
import { Card, FormControl, FormGroup, Grid, Icon } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import MultiSelect from "../../components/MultiSelect";
import { mapActionsToProps } from "../../redux/profiling/data";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import { globalHistory } from "./../../history";

function deduplicate(arr) {
  let isExist = (arr, x) => arr.indexOf(x) > -1;
  let ans = [];

  arr.forEach((element) => {
    if (!isExist(ans, element)) ans.push(element);
  });

  return ans;
}

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
  campaign: {
    position: "absolute",
    bottom: theme.spacing.unit * 4,
    right: theme.spacing.unit * 4,
  },
  campaignIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
});

class PhoneNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      openCampaignConfig: false,
      dataTags: [],
      dataLocation: [],
      tagsState: {},
      itemTags: [],
      itemBiography: [],
      campaignConfig: false,
      filterData: [],
      value: {
        ...this.props.biography.value,
      },
    };
  }
  async componentDidMount() {
    await this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "id", numeric: true, disablePadding: false, label: "Số điện thoại" },
    { id: "fullname", numeric: true, disablePadding: false, label: "Họ tên" },
    { id: "gender", numeric: true, disablePadding: false, label: "Giới tính" },
    { id: "dod", numeric: true, disablePadding: false, label: "Ngày sinh" },
    {
      id: "cityId",
      numeric: true,
      disablePadding: false,
      label: "Tỉnh/Thành phố",
    },
    {
      id: "address",
      numeric: true,
      disablePadding: false,
      label: "Quận/huyện",
    },
    { id: "tags", numeric: true, disablePadding: false, label: "Tags" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "id":
            case "cityId":
            case "gender":
            case "type":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListProfiling(filters.pageSize, filters.page, {
      where,
    });
    this.props.countListProfiling({ where });
    this.props.getTagsProfiling();
    this.props.getLocationProfiling();
    this.props.getBiographyProfiling();
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState(
      {
        filters,
      },
      () => {
        this.setState({
          itemAge: {
            key: "biography.age",
            value: [
              { from: `${filters.where.from}`, to: `${filters.where.to}` },
            ],
          },
        });
      }
    );
  };

  handleSubmit = (e) => {
    const { itemTags, itemLocation, itemBiography, itemAge } = this.state;

    // this.props.getDataTagsProfiling('sample', {
    //     filters: [
    //         itemTags, itemLocation, ...itemBiography, itemAge
    //     ]
    // })
    this.setState(
      {
        campaignConfig: true,
        filterData: [itemTags, itemLocation, ...itemBiography, itemAge],
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleChange = (name) => {
    return (e) => {
      this.setState(
        {
          tagsState: {
            ...this.state.tagsState,
            [name]: e.target.value,
          },
        },
        () => {
          let arr = [];
          for (const key in this.state.tagsState) {
            if (this.state.tagsState.hasOwnProperty(key)) {
              const value = this.state.tagsState[key];
              arr.push({ key: key, value: [value] });
            }
          }
          const newData = deduplicate(arr);
          this.setState({ itemBiography: newData });
        }
      );
    };
  };

  handlePush = (item) => {
    const { dataTags } = this.state;
    if (item !== null && item !== undefined) {
      item.map((i) => {
        dataTags.push(i.value);
      });
      const newData = deduplicate(dataTags);
      this.setState({
        itemTags: { key: "interest", value: [`${newData}`], name: "quan tâm" },
      });
    }
  };

  handlePushLocation = (item) => {
    const { dataLocation } = this.state;
    if (item !== null && item !== undefined) {
      item.map((i) => {
        dataLocation.push(i.value);
      });
      const newData = deduplicate(dataLocation);
      this.setState({
        itemLocation: { key: "province", value: [`${newData}`], name: "tỉnh" },
      });
    }
  };

  render() {
    const {
      classes,
      listProfiling,
      count,
      loading,
      biography,
      tags,
      location,
    } = this.props;
    const { filters } = this.state;
    const listProfilingResult =
      typeof listProfiling === "object"
        ? Object.keys(listProfiling).map((key) => listProfiling[key])
        : listProfiling;
    const biographyResult =
      typeof biography === "object"
        ? Object.keys(biography).map((key) => biography[key])
        : biography;
    const tagsResult =
      typeof tags === "object"
        ? Object.keys(tags).map((key) => tags[key])
        : tags;
    const locationResult =
      typeof location === "object"
        ? Object.keys(location).map((key) => location[key])
        : location;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={6}>
                        {locationResult
                          ? locationResult.map((item, key) => {
                              return (
                                <MultiSelect
                                  suggestions={item.tagValue}
                                  label="Tỉnh"
                                  placeholder="Lựa chọn tỉnh"
                                  tags={false}
                                  handlePushLocation={this.handlePushLocation}
                                />
                              );
                            })
                          : null}
                      </Grid>
                      <Grid item md={6}>
                        {tagsResult
                          ? tagsResult.map((item, key) => {
                              return (
                                <MultiSelect
                                  suggestions={item.tagValue}
                                  label="Chủ đề"
                                  placeholder="Lựa chọn chủ đề"
                                  tags={true}
                                  handlePush={this.handlePush}
                                />
                              );
                            })
                          : null}
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={24}
                      style={{
                        marginTop: 10,
                        justifyContent: "center",
                        display: "flex",
                      }}>
                      {biographyResult
                        ? biographyResult.map((item, key) => {
                            if (item.key != "biography.age") {
                              return (
                                <Grid item md={2} key={key}>
                                  <SelectValidator
                                    id="outlined-full-width"
                                    margin="normal"
                                    select
                                    SelectProps={{
                                      MenuProps: {
                                        className: classes.menu,
                                        shrink: true,
                                      },
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    label={item.name}
                                    variant="outlined"
                                    className={classes.input}
                                    onChange={this.handleChange(item.key)}
                                    value={this.state.tagsState[item.key]}
                                    name={item.key}>
                                    <MenuItem>Tất cả</MenuItem>
                                    {item.tagValue.map((item) => {
                                      if (item == true) {
                                        return (
                                          <MenuItem key={item} value={item}>
                                            Có
                                          </MenuItem>
                                        );
                                      } else if (item == false) {
                                        return (
                                          <MenuItem key={item} value={item}>
                                            Không
                                          </MenuItem>
                                        );
                                      } else {
                                        return (
                                          <MenuItem key={item} value={item}>
                                            {item}
                                          </MenuItem>
                                        );
                                      }
                                    })}
                                  </SelectValidator>
                                </Grid>
                              );
                            } else {
                              return (
                                <React.Fragment>
                                  <Grid item md={2}>
                                    <SelectValidator
                                      id="outlined-select-currency"
                                      select
                                      label="Từ độ tuổi"
                                      className={classes.input}
                                      value={filters.where.from}
                                      onChange={this.handleSearch}
                                      SelectProps={{
                                        MenuProps: {
                                          className: classes.menu,
                                        },
                                      }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      margin="normal"
                                      variant="outlined"
                                      name="from">
                                      {item.tagValue.from.map((i) => {
                                        return (
                                          <MenuItem key={i} value={i}>
                                            {i}
                                          </MenuItem>
                                        );
                                      })}
                                    </SelectValidator>
                                  </Grid>
                                  <Grid item md={2}>
                                    <SelectValidator
                                      id="outlined-select-currency"
                                      select
                                      label="Đến độ tuổi"
                                      className={classes.input}
                                      value={filters.where.to}
                                      onChange={this.handleSearch}
                                      SelectProps={{
                                        MenuProps: {
                                          className: classes.menu,
                                        },
                                      }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      margin="normal"
                                      variant="outlined"
                                      name="to"
                                      validators={[
                                        `minNumber: ${filters.where.from}`,
                                      ]}
                                      errorMessages={[
                                        "Tuổi phải lớn hơn tuổi bắt đầu",
                                      ]}>
                                      {item.tagValue.to.map((i) => {
                                        return (
                                          <MenuItem key={i} value={i}>
                                            {i}
                                          </MenuItem>
                                        );
                                      })}
                                    </SelectValidator>
                                  </Grid>
                                </React.Fragment>
                              );
                            }
                          })
                        : null}
                      <Grid
                        item
                        md={2}
                        style={{ alignItems: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                      {this.state.campaignConfig == true ? (
                        <Fab
                          variant="extended"
                          color="primary"
                          className={classes.margin}
                          onClick={() =>
                            this.setState({ openCampaignConfig: true })
                          }>
                          <Icon className={classes.extendedIcon}>input</Icon>
                          Phân bổ chiến dịch
                        </Fab>
                      ) : null}
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách số điện thoại"
          items={listProfilingResult}
          rowsPerPage={filters.pageSize}
          count={count ? count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleView={this.handleView}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
        {this.state.openCampaignConfig ? (
          <Fab
            className={classes.campaign}
            color="primary"
            variant="extended"
            onClick={this.handleConfigCampaign}>
            <Icon className={classes.campaignIcon}>input</Icon>
            Phân bổ chiến dịch
          </Fab>
        ) : null}
        <Dialog open={loading} title="Đang tìm kiếm ..." />
      </React.Fragment>
    );
  }
}

PhoneNumber.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listProfiling: state.profiling.profiling,
  count: state.profiling.count,
  loading: state.profiling.loading,
  tags: state.profiling.tags,
  biography: state.profiling.biography,
  location: state.profiling.location,
});

PhoneNumber = connect(mapStateToProps, mapActionsToProps)(PhoneNumber);

export default withStyles(styles)(PhoneNumber);
